import React, { FC, PropsWithChildren, useEffect, useRef } from 'react';

interface Props {
  onClickOutside: () => void;
}

export const WithClickOutside: FC<Props> = (props: PropsWithChildren<Props>) => {
  const ref = useRef();

  useEffect(() => {
    document.addEventListener('click', handleClickInOrOutside);
    return () => document.removeEventListener('click', handleClickInOrOutside);
  }, []);

  const handleClickInOrOutside = (event: MouseEvent) => {
    const withinBoundaries = event.composedPath().includes(ref.current);

    if (!withinBoundaries) {
      props.onClickOutside();
    }
  };

  return <div ref={ref}>{props.children}</div>;
};
